import useRoleCreateRouteConfig from "../../../routes/configs/roles/RoleCreateRouteConfig";
import useRoleEditRouteConfig from "../../../routes/configs/roles/RoleEditRouteConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useDuplicateRowActionConfig from "../main/config/rowAction/default/DuplicateRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";

function RolesDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("roles");

  //Set the datatable fetch info
  config.setFetchRequest("roles");

  //Set the datatable order by
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //set the datatable columns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("role", useRoleEditRouteConfig()),
    useDuplicateRowActionConfig("role"),
    useDeleteRowActionConfig("role"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("role", useRoleCreateRouteConfig()),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default RolesDataTable;
